import { useEffect, useRef, useState } from "react";
import { timerAPI } from '../lib/api';

export const useActiveTimer = (intervalMs = 0) => {
  const [activeTimer, setActiveTimer] = useState(null);
  const intervalRef = useRef(null);

  const checkActiveTimer = async () => {
    try {
      const res = await timerAPI.getActive();
      if (res.data && res.data.task_id) {
        setActiveTimer(res.data);
      } else {
        setActiveTimer(null);
      }
    } catch {
      setActiveTimer(null);
    }
  };

  useEffect(() => {
    checkActiveTimer();
    // hanya buat interval kalau belum ada
    if (!intervalRef.current && intervalMs > 0) {
      intervalRef.current = setInterval(checkActiveTimer, intervalMs);
    }
  }, [intervalMs]);

  return { activeTimer, setActiveTimer, checkActiveTimer };
};